'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

export default function Home() {
  const router = useRouter();
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    
    const checkAuth = async () => {
      if (!isMounted) return;
      
      setIsLoading(true);
      
      try {
        // Wait a bit for MSAL to initialize completely
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Only wait for in-progress operations if we're not already authenticated
        // This prevents unnecessary waiting if auth is already complete
        // Using type assertion to handle the string literal vs enum mismatch
        if (!isAuthenticated && (inProgress as any) !== 'none') {
          // Maximum time to wait for in-progress auth (3 seconds)
          let timeout = 30; // 30 * 100ms = 3 seconds
          
          while ((inProgress as any) !== 'none' && timeout > 0 && isMounted) {
            await new Promise(resolve => setTimeout(resolve, 100));
            timeout--;
          }
        }
        
        if (!isMounted) return;
        
        if (isAuthenticated) {
          router.push('/main');
        } else {
          router.push('/login');
        }
      } catch (error) {
        console.error("Authentication error:", error);
        if (isMounted) {
          router.push('/login');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    checkAuth();
    
    return () => {
      isMounted = false;
    };
  }, [isAuthenticated, inProgress, router]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-foreground/70 flex flex-col items-center">
          <div className="w-8 h-8 border-t-2 border-primary rounded-full animate-spin mb-3"></div>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-foreground/70 flex flex-col items-center">
        <div className="w-8 h-8 border-t-2 border-primary rounded-full animate-spin mb-3"></div>
        Redirecting...
      </div>
    </div>
  );
}